import { render } from "./ProjectDescriptionText.vue?vue&type=template&id=1693ed78&scoped=true"
import script from "./ProjectDescriptionText.vue?vue&type=script&lang=js"
export * from "./ProjectDescriptionText.vue?vue&type=script&lang=js"

import "./ProjectDescriptionText.vue?vue&type=style&index=0&id=1693ed78&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1693ed78"]])

export default __exports__